export const shouldLoad = () => document.querySelector('[data-controller~=event-dates]') !== undefined;
